import { render } from "./Grupos.vue?vue&type=template&id=26bbdbb0&ts=true"
import script from "./Grupos.vue?vue&type=script&lang=ts"
export * from "./Grupos.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__